import { Info, TrendingUp } from "lucide-react";
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface ThirtyDayForecastMiniCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function ThirtyDayForecastMiniCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: ThirtyDayForecastMiniCardThumbnailProps) {
  return (
    <ScaledThumbnail isHovered={isHovered} alwaysVisible={alwaysVisible}>
      <Card
        className="w-[300px]"
        style={{ borderLeft: "3px solid var(--color-info-400)" }}
      >
        <CardContent className="p-4 flex flex-col gap-4">
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-center gap-1 min-w-0">
              <span className="text-base font-medium text-neutral-800 truncate">
                30-Day Forecast
              </span>
              <Info className="h-3 w-3 text-muted-foreground flex-shrink-0" />
            </div>
            <div
              className="h-9 w-9 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: "var(--color-info-100)" }}
            >
              <TrendingUp
                className="h-4 w-4"
                style={{ color: "var(--color-info-600)" }}
              />
            </div>
          </div>

          <div>
            <div className="text-2xl font-bold text-neutral-900 tracking-tight">
              £312,850
            </div>
            <div className="flex items-center gap-1 text-xs mt-1">
              <span className="font-semibold text-neutral-800">+8.8%</span>
              <span className="font-normal text-neutral-800">vs current</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}
